import React from 'react'
import { FormattedMessage } from 'react-intl'

import Modal from 'components/Modal'
import Button from 'components/Button'

const SensitiveSpeciesWarningModal = ({ isOpen, onConfirm, onClose, isSubmitting = false, isLoading = false }) => {
  const submitting = isSubmitting || isLoading
  const handleClose = () => {
    if (!submitting && onClose) {
      onClose()
    }
  }

  const handleConfirm = async () => {
    if (submitting || !onConfirm) return
    await onConfirm()
  }

  return (
    <Modal
      isOpen={isOpen}
      toggleModal={handleClose}
      modalTitleId="sensitiveSpeciesWarningTitle"
      width="616px"
      padding="0 32px 32px 32px"
    >
      <p style={{ fontSize: '14px', lineHeight: '24px' }}>
        <FormattedMessage id="sensitiveSpeciesWarningBody" />
      </p>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px' }}>
        <Button
          height="40px"
          marginTop="0px"
          type="primary"
          onClick={handleConfirm}
          disabled={submitting}
        >
          <FormattedMessage id={submitting ? 'submitting' : 'okay'} />
        </Button>
      </div>
    </Modal>
  )
}

export default SensitiveSpeciesWarningModal

